<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { getDbDumpLink, ApiError } from '@/api'
import { downloadFileOrOpen } from '@/telegramWebApp'
import CommandLink from '@/components/CommandLink.vue'

const { t } = useI18n()
const dumpBusy = ref(false)
const dumpError = ref('')

// The link works without a session (the download popup can't send one) and only for a minute.
async function downloadDump() {
  dumpBusy.value = true
  dumpError.value = ''
  try {
    const link = await getDbDumpLink()
    downloadFileOrOpen(link.url, link.file_name)
  } catch (e) {
    dumpError.value = e instanceof ApiError ? e.message : t('admin.dump.failed')
  } finally {
    dumpBusy.value = false
  }
}
</script>

<template>
  <i18n-t keypath="admin.dump.hint" tag="p" class="hint">
    <template #command><CommandLink command="dump_db" /></template>
  </i18n-t>
  <p v-if="dumpError" class="error">{{ dumpError }}</p>
  <button type="button" :disabled="dumpBusy" @click="downloadDump">{{ t('admin.dump.download') }}</button>
</template>

<style scoped>
.hint {
  color: var(--tg-hint-color);
  font-size: 0.85rem;
}

.error {
  color: var(--tg-destructive-text-color);
}
</style>
